import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgr68gq35d: FaireProductEntity = {
  token: "p_vgr68gq35d",
  type: "product",
  name: 'Panel Goblet-6.5"H(12oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/02a82995a87a6f1ad158a3d3f5ee82df385ceb5568670a6c56d659e9ed9e7067.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2db8c1a4067ebfd172e232c5ded322325f8ed2525578ad56d04ae74a0a83a096.jpeg",
    "https://cdn.faire.com/fastly/804c0586e730aa061c2b9ab7a19021b22ab135d18a97bfa856a2220956535aad.jpeg",
    "https://cdn.faire.com/fastly/d19b0333341d29433f43ff1816d6556d6e2db91a7e96fbb5131ecedb1f12bf6e.jpeg",
    "https://cdn.faire.com/fastly/037ba81e3aa5a117e8eea46d395895b0b6f9cd0e7a4a1cd3b50b913fa599a71d.jpeg",
    "https://cdn.faire.com/fastly/e2cfdb233c274cdbe8b08c7d207f9b4741a161e35f7fe99054d3661cf1e99c6c.jpeg",
    "https://cdn.faire.com/fastly/c47af123933197f07bc9558781d4c332b769ead6f46f83637f48a457e118bda1.jpeg",
    "https://cdn.faire.com/fastly/ada81b4d6dc652470cfe8fbaf99ff4a720d2e55cc66b1bb460350b393d1ffdae.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Add some regal color to your entertaining with our exquisite panel goblets. Crafted out of glass, this stemmed piece is the perfect vessel to elevate your entertaining and celebrating needs. Dishwasher safe. Also available in other colors.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:11.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
